module.exports = __webpack_public_path__ + "img/bg1.ff40fe35.png";